<template>
  <div>
    <apexchart type="area" height="200" :options="chartOptions" :series="series"></apexchart>
  </div>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';

export default {
  name: `StatisticsTimelineChart`,

  props: {
    interventions: Array,
    from: String,
    to: String,
  },

  data: () => ({
  }),

  computed: {
    byDateInterventions() {
      const byDateInterventions = {};

      this.interventions.forEach(intervention => {
        const date = moment(intervention.createdAt).format(`YYYYMMDD`);
        if (!byDateInterventions[date]) {
          byDateInterventions[date] = [];
        }
        byDateInterventions[date].push(intervention);
      });

      return byDateInterventions;
    },
    byDateSerie() {
      const { byDateInterventions } = this;
      const dates = [];
      const fromDate = moment(this.from, `YYYYMMDD`);
      const toDate = moment(this.to, `YYYYMMDD`);
      let date = fromDate.clone();
      while (date.isSameOrBefore(toDate)) {
        const interventions = byDateInterventions[date.format(`YYYYMMDD`)] || [];
        dates.push({
          date,
          dateJS: date.valueOf(),
          count: interventions.length,
          label: date.format(`DD/MM`),
        });
        date = date.add(1, `days`);
      }

      return dates;
    },

    series() {
      return [{
        name: `Interventions`,
        data: _.map(this.byDateSerie, `count`),
      }];
    },
    chartOptions() {
      return {
        chart: {
          type: `area`,
          height: 200,
          zoom: {
            enabled: false,
          },
          toolbar: {
            show: false,
          },
        },
        title: {
          text: `Chronologie`,
        },
        colors: [`#008ffb`],
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: `smooth`,
        },
        labels: _.map(this.byDateSerie, `dateJS`),
        xaxis: {
          labels: {
            formatter: date => moment(date).format(`DD/MM`),
          },
          type: `datetime`,
        },
        // yaxis: {
        //   opposite: true,
        // },
        legend: {
          horizontalAlign: `left`,
        },
      };
    },
  },
};
</script>

<style lang="scss">
</style>
